"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var CliffEnded_1 = __importDefault(require("../../../Icons/Notifications/CliffEnded"));
var i18N = {
    en: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "The cliff period to vest funds has ended. Check the",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "contract status"),
            ' ',
            "now!")); },
        title: function (proposalTitle) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Funds are ready to vest for your project \"",
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, proposalTitle),
            "\"")); }
    },
    es: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "El per\u00EDodo de espera para la adjudicaci\u00F3n de fondos ha finalizado. \u00A1Revisa el",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "estado del contrato"),
            ' ',
            "ahora!")); },
        title: function (proposalTitle) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Los fondos est\u00E1n listos para ser utilizados en tu proyecto \"",
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, proposalTitle),
            "\"")); }
    },
    zh: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u8D44\u91D1\u91CA\u653E\u7684\u7B49\u5F85\u671F\u5DF2\u7ED3\u675F\u3002",
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "\u73B0\u5728\u67E5\u770B\u5408\u540C\u72B6\u6001\uFF01"))); },
        title: function (proposalTitle) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u60A8\u7684\u9879\u76EE\u201C",
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, proposalTitle),
            "\u201D\u7684\u8D44\u91D1\u5DF2\u51C6\u5907\u597D\u91CA\u653E")); }
    }
};
var GovernanceCliffEndedNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(CliffEnded_1.default, null) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title(notification.metadata.proposalTitle)),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata.link))));
};
exports.default = GovernanceCliffEndedNotification;
